<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <div>
        <message-component id="message" v-model="isMessage">{{ message }}</message-component>
        <v-row justify="center">
            <v-col cols="12" xl="3">
                <label-component fontSize="35" fontWeight="bold" style="margin-top: 30px;">初期パスワード更新</label-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component>新しいパスワード</label-component>
            </v-col>
            <v-col cols="12" xl="3">
                <ValidationProvider name="パスワード" rules="required|min:8" vid="password" v-slot="{ errors }">
                    <v-text-field outlined clearable v-disabled-icon-focus v-model="password" type='password' hint="大文字、小文字、数字、記号を含む8文字以上でご入力ください" :error-messages="errors" background-color="white"></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="12" xl="2">
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <label-component>新しいパスワード（確認）</label-component>
            </v-col>
            <v-col cols="12" xl="3">
                <ValidationProvider name="パスワード" rules="required|min:8|confirmed:password" v-slot="{ errors }">
                    <v-text-field outlined clearable v-disabled-icon-focus v-model="password_confirm" hint="大文字、小文字、数字、記号を含む8文字以上でご入力ください" type='password' :error-messages="errors" background-color="white"></v-text-field>
                </ValidationProvider>
            </v-col>
            <v-col cols="12" xl="2">
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" xl="2">
                <button-component block @click="update" :disabled="invalid" color="red">パスワード更新</button-component>
            </v-col>
        </v-row>
    </div>
</ValidationObserver>
</template>

<script>
    export default {
        data: function () {
            return {
                old_password: null,
                password: null,
                password_confirm: null,
                // メッセージ
                message: null,
                success: false,
            }
        },
        methods: {
            update: function (event) {
                axios.post(
                    '/documents/initialize',
                    {
                        'old_password': this.old_password,
                        'password': this.password,
                        'password_confirm': this.password_confirm,
                    }
                )
                .then(res => {
                    this.success = res.data.success;
                    this.message = res.data.message;
                    if (this.success) {
                        window.location = "/documents/dashboard";
                    }
                }).catch(res => {
                    // console.log(res);
                    this.success = false;
                    this.message = "処理に失敗しました";
                }).finally(() => {
                });
            }
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
    }
</script>